var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`d-flex justify-content-${_vm.alignment} py-${_vm.py}`},[_c('b-pagination',_vm._g(_vm._b({staticClass:"mb-0 custom-style",attrs:{"total-rows":_vm.total,"per-page":_vm.perPage,"hide-goto-end-buttons":"","first-number":"","last-number":""}},'b-pagination',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }